import firebase from 'firebase'
import {
    mapGetters,
    mapMutations,
    mapActions,
  } from 'vuex'
  export default {
    data () {
      return {
        needRegister: false,
        loginForm: {
          email: '',
          password: ''
        },
        registerForm: {
          email: '',
          password: '',
          password2: ''
        },
        email: '',
        password: '',
        missingMail: false,
      }
    },
    methods: {
      /**
       * Function to login
       */
      login () {
        firebase.auth().signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
          this.$router.push('/management')
        }).catch(err => {
          console.log(err)
        })
      },
      showRegister () {
        this.needRegister = true
      },
      showLogin () {
        this.needRegister = false
      }
    }
  }
  


// WEBPACK FOOTER //
// ./src/views/admin/login/login.js